module.exports = __webpack_public_path__ + "static/img/zhuanjie.15054a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zhuanjie.png
// module id = kRU9
// module chunks = 24